import * as React from 'react';
import CollapsibleCard from '../../../../common/CollapsibleCard';
import FormInput from '../../../../common/form/Input';
import { Lead2LeasePropertyConfiguration } from '../../../../../api/PropertyIntegration';
import { userIsCompanyManageUser, userIsPropertyManageUser, userIsSystemManageUser } from '../../../../../utilities/identity';

interface Props {
    config?: Lead2LeasePropertyConfiguration;
    update: (newConfig?: Lead2LeasePropertyConfiguration) => void;
}

const Lead2LeaseConfigurationSection = (props: Props) => {
    const isUser =
    userIsCompanyManageUser() ||
    userIsPropertyManageUser() ||
    userIsSystemManageUser();
    return(
    <CollapsibleCard
        cardTitle="Lead2Lease Configuration"
        cardOpen={!!props.config}
        onCardOpenChange={open => {
            if (isUser)  return;
            props.update(open ? { lead2LeasePropertyId: '' } : undefined)}
        }
    >
        <div>
            {props.config && (
                <>
                    <FormInput
                        labelProps={{
                            labelText: 'Property ID',
                            invalidText: 'Please enter a Lead2Lease Property ID'
                        }}
                        inputProps={{
                            id: 'lead2lease-property-id',
                            name: 'lead2leasePropertyId',
                            value: props.config.lead2LeasePropertyId,
                            type: 'string',
                            required: true,
                            disabled: isUser
                        }}
                        onChange={(_name, value) =>
                            !isUser && props.update({
                                ...props.config!,
                                lead2LeasePropertyId: value.toString()
                            })
                        }
                    />
                </>
            )}
        </div>
    </CollapsibleCard>
);
};
export default Lead2LeaseConfigurationSection;



// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/integrationControls/Lead2LeaseConfigurationSection.tsx